
import { OrbitControls } from '@react-three/drei';

/**
 * Controls component which adds possibility to pan, zom and rotate the scene
 * 
 * @param {*} param0 
 * @returns 
 */
const Controls = ({ rotate, target, smooth = false, enabled = true }) => {
    const { x, y, z } = target;
    return <OrbitControls enableRotate={!enabled ? false : rotate} enableDamping={smooth} enablePan={enabled} target={[x, y, z]} />;
};

export default Controls;